module.exports = __webpack_public_path__ + "img/how-it-work-new.8b4d4bfc.png";